import React, { createContext, useCallback, useContext, useState } from 'react';
import LoadingDialog from '../components/LoadingDialog';

interface LoadingDialogContextDTO {
  handleLoadingDialog: (loading: boolean) => void;
}

const LoadingDialogContext = createContext<LoadingDialogContextDTO>(
  {} as LoadingDialogContextDTO,
);

const LoadingDialogProvider: React.FC = ({ children }) => {
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false);

  const handleLoadingDialog = useCallback((open: boolean) => {
    setOpenLoadingDialog(open);
  }, []);

  return (
    <LoadingDialogContext.Provider value={{ handleLoadingDialog }}>
      {children}
      <LoadingDialog open={openLoadingDialog} />
    </LoadingDialogContext.Provider>
  );
};

function useLoadingDialog(): LoadingDialogContextDTO {
  return useContext(LoadingDialogContext);
}

export { LoadingDialogProvider, useLoadingDialog };
